import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function MenuItem({ title, icon, submenu, href, realState, items }) {
  let location = useLocation();

  const [click, setClick] = useState(false);

  useEffect(() => {
    if (submenu && (location.pathname.startsWith(items[0].href) || location.pathname.startsWith(items[1].href))) {
      setClick(true);
    } else {
      setClick(false);
    }
  }, [location]);

  const openSubMenuHandler = () => {
    setClick(!click);
  };

  if (!realState && !submenu) {
    return (
      <>
        {href == '/help' || href == '/requests' ? (
          <>
            <Link
              to={href}
              className={`
              ${
                location.pathname.includes(href)
                  ? 'text-primary font-semibold'
                  : 'text-text-normal hover:text-text-hard hover:font-medium transition-all font-normal'
              }
              w-full px-3 py-2 gap-3 text-sm cursor-pointer flex flex-row items-center rounded-lg`}
            >
              {icon}
              <p>{title}</p>
            </Link>
          </>
        ) : (
          <button
            disabled={true}
            className={`w-full px-3 py-2 gap-3 text-sm cursor-not-allowed flex flex-row items-center rounded-lg bg-light-grey text-text-normal`}
          >
            {icon}
            <p>{title}</p>
          </button>
        )}
      </>
    );
  }

  if (submenu) {
    return (
      <div>
        <button
          disabled={!realState}
          onClick={openSubMenuHandler}
          className={`disabled:bg-light-grey disabled:cursor-not-allowed disabled:text-text-normal disabled:hover:text-text-normal disabled:rounded-lg disabled:hover:font-normal w-full px-3 py-2 gap-3 text-sm cursor-pointer flex flex-row items-center justify-between rounded-lg rounded-b-none group hover:text-primary
            ${
              click
                ? 'text-primary bg-secondary font-semibold'
                : 'text-text-normal hover:text-text-hard hover:font-medium transition-all font-normal'
            }`}
        >
          <div className="flex flex-row items-center gap-3">
            {icon}
            <p>{title}</p>
          </div>
          <svg
            className={`${click ? 'rotate-180' : 'rotate-0'} transition-all`}
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.05859 9.36668L10.0003 12.3L12.9419 9.36668"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div
          className={`${
            click ? 'max-h-20' : 'max-h-0'
          } bg-gray w-full transition-all flex flex-col items-start gap-3 rounded-b-lg px-5 text-sm overflow-hidden relative`}
        >
          {(location.pathname.startsWith(items[0].href) || location.pathname.startsWith(items[1].href)) && (
            <div
              className={`absolute right-4 h-2 w-0.5 rounded-full transition-all ${
                location.pathname.includes(items[0].href) ? 'top-4' : 'top-12'
              } bg-primary`}
            ></div>
          )}
          <Link
            className={`pr-2 pt-2.5 text-sm
                ${
                  location.pathname.includes(items[0].href)
                    ? 'text-primary font-semibold'
                    : 'text-[#474747] hover:text-[#050505] hover:font-medium transition-all font-normal'
                }
                `}
            to={items[0].href}
          >
            {items[0].title}
          </Link>
          <Link
            className={`pr-2 pb-2.5 text-sm
                ${
                  location.pathname.includes(items[1].href)
                    ? 'text-primary font-semibold'
                    : 'text-[#474747] hover:text-[#050505] hover:font-medium transition-all font-normal'
                }
                `}
            to={items[1].href}
          >
            {items[1].title}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        `w-full px-3 py-2 transition-all gap-3 text-sm cursor-pointer flex flex-row items-center rounded-lg group ${
          isActive
            ? 'text-primary font-semibold'
            : 'text-[#474747] hover:text-[#050505] hover:font-medium transition-all font-normal'
        }`
      }
    >
      {icon}
      <p>{title}</p>
    </NavLink>
  );
}
